module.exports = __webpack_public_path__ + "static/media/3.question.a5785253.mp4";